<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 0a12.01 12.01 0 1 0 12 12c0-6.62-5.38-12-12-12m0 22a10.01 10.01 0 0 1 0-20 10.01 10.01 0 0 1 0 20m0-16a4 4 0 0 0 0 8q.97-.01 1.77-.43Q13.07 16 10 16a1 1 0 1 0 0 2c3.81 0 6-2.26 6-6.2V10a4 4 0 0 0-4-4m0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4"/></svg>
</template>
